import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { DelegateTab } from "@/components/undertake/DelegateTab";
import { UndertakePile } from "@/components/undertake/UndertakePile";
import { ReviewTab } from "@/components/undertake/ReviewTab";
import { OnlyTheBraveButton } from "@/components/GeniusAvenue";

export default function EnjoyPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState("undertake");
  const tabs = ["undertake", "delegate", ...(user?.is_god ? ["review"] : [])];

  return (
    <div className="pb-32">
      <div className="flex justify-center mb-8"><OnlyTheBraveButton /></div>
      <div className="flex gap-8 mb-10 justify-center" data-testid="enjoy-subtabs">
        {tabs.map((t) => (
          <button
            key={t}
            data-testid={`enjoy-subtab-${t}`}
            onClick={() => setTab(t)}
            className="text-sm tracking-widest transition-colors duration-200"
            style={{
              color: tab === t ? "var(--accent)" : "var(--text-muted)",
              paddingBottom: "4px",
              borderBottom: tab === t ? "1px solid var(--accent)" : "1px solid transparent",
            }}
          >
            {t}
          </button>
        ))}
      </div>
      {tab === "delegate" && <DelegateTab />}
      {tab === "undertake" && <UndertakePile />}
      {tab === "review" && <ReviewTab />}
    </div>
  );
}
